import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

export interface GroupMenuItem {
	key: string;
	label: string;
	onClick: () => void;
	disabled?: boolean;
	testId?: string;
}

export type CountTone = 'neutral' | 'complete' | 'outstanding';

export const COUNT_TONE_COLORS: Record<CountTone, { bg: string; color: string }> = {
	neutral: {
		bg: defaultTheme.v3.colors.gray[4],
		color: defaultTheme.v3.colors.dark[4],
	},
	complete: {
		bg: '#edfdf3',
		color: defaultTheme.v3.colors.teal[8],
	},
	outstanding: {
		bg: defaultTheme.v3.colors.gray[4],
		color: defaultTheme.v3.colors.dark[4],
	},
};
